// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("vodafone/vodafone-lt/Vodafone_Lt.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("vodafone/vodafone-bk/Vodafone_Bk.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("vodafone/vodafone-rg/Vodafone_Rg.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("vodafone/vodafone-rg/Vodafone_Rg.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("vodafone/vodafone-rg/Vodafone_Rg.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("vodafone/vodafone-md/Vodafone_Md.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("vodafone/vodafone-sbd/Vodafone_SBd.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("vodafone/vodafone-bd/Vodafone_Bd.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("vodafone/vodafone-xbd/Vodafone_XBd.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("amigo/amigo-Light.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("amigo/amigo-Light.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("amigo/amigo-Light.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("amigo/amigo-Regular.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("amigo/amigo-Regular.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("amigo/amigo-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("amigo/amigo-Medium.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_16___ = new URL("amigo/amigo-Medium.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_17___ = new URL("amigo/amigo-Medium.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_18___ = new URL("amigo/amigo-Bold.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_19___ = new URL("amigo/amigo-Bold.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_20___ = new URL("amigo/amigo-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_21___ = new URL("amigo/amigo-Black.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_22___ = new URL("amigo/amigo-Black.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_23___ = new URL("amigo/amigo-Black.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_16___);
var ___CSS_LOADER_URL_REPLACEMENT_17___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_17___);
var ___CSS_LOADER_URL_REPLACEMENT_18___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_18___);
var ___CSS_LOADER_URL_REPLACEMENT_19___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_19___);
var ___CSS_LOADER_URL_REPLACEMENT_20___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_20___);
var ___CSS_LOADER_URL_REPLACEMENT_21___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_21___);
var ___CSS_LOADER_URL_REPLACEMENT_22___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_22___);
var ___CSS_LOADER_URL_REPLACEMENT_23___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_23___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* LOAD VODAFONE FONTS */

@font-face {
    font-family: 'Vodafone';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('truetype');
    font-style: normal;
    font-weight: 200;
    font-display: swap;
}

@font-face {
    font-family: 'Vodafone';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('truetype');
    font-style: normal;
    font-weight: 350;
    font-display: swap;
}

@font-face {
    font-family: 'Vodafone';
    src:
        url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('woff2'),
        url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format('woff'),
        url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format('truetype');
    font-style: normal;
    font-weight: 400;
    font-display: swap;
}

@font-face {
    font-family: 'Vodafone';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format('truetype');
    font-style: normal;
    font-weight: 500;
    font-display: swap;
}

@font-face {
    font-family: 'Vodafone';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_6___}) format('truetype');
    font-style: normal;
    font-weight: 600;
    font-display: swap;
}

@font-face {
    font-family: 'Vodafone';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_7___}) format('truetype');
    font-style: normal;
    font-weight: 700;
    font-display: swap;
}

@font-face {
    font-family: 'Vodafone';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_8___}) format('truetype');
    font-style: normal;
    font-weight: 900;
    font-display: swap;
}

/* LOAD AMIGO FONTS */

@font-face {
    font-family: 'Amigo';
    font-weight: 200;
    src:
        url(${___CSS_LOADER_URL_REPLACEMENT_9___}) format('woff2'),
        url(${___CSS_LOADER_URL_REPLACEMENT_10___}) format('woff'),
        url(${___CSS_LOADER_URL_REPLACEMENT_11___}) format('truetype');
}

@font-face {
    font-family: 'Amigo';
    font-weight: 400;
    src:
        url(${___CSS_LOADER_URL_REPLACEMENT_12___}) format('woff2'),
        url(${___CSS_LOADER_URL_REPLACEMENT_13___}) format('woff'),
        url(${___CSS_LOADER_URL_REPLACEMENT_14___}) format('truetype');
}

@font-face {
    font-family: 'Amigo';
    font-weight: 500;
    src:
        url(${___CSS_LOADER_URL_REPLACEMENT_15___}) format('woff2'),
        url(${___CSS_LOADER_URL_REPLACEMENT_16___}) format('woff'),
        url(${___CSS_LOADER_URL_REPLACEMENT_17___}) format('truetype');
}

@font-face {
    font-family: 'Amigo';
    font-weight: 700;
    src:
        url(${___CSS_LOADER_URL_REPLACEMENT_18___}) format('woff2'),
        url(${___CSS_LOADER_URL_REPLACEMENT_19___}) format('woff'),
        url(${___CSS_LOADER_URL_REPLACEMENT_20___}) format('truetype');
}

@font-face {
    font-family: 'Amigo';
    font-weight: 900;
    src:
        url(${___CSS_LOADER_URL_REPLACEMENT_21___}) format('woff2'),
        url(${___CSS_LOADER_URL_REPLACEMENT_22___}) format('woff'),
        url(${___CSS_LOADER_URL_REPLACEMENT_23___}) format('truetype');
}
`, "",{"version":3,"sources":["webpack://./src/assets/fonts/stylesheet.css"],"names":[],"mappings":"AAAA,wBAAwB;;AAExB;IACI,uBAAuB;IACvB,+DAAmE;IACnE,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,uBAAuB;IACvB,+DAAmE;IACnE,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,uBAAuB;IACvB;;;kEAGkE;IAClE,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,uBAAuB;IACvB,+DAAmE;IACnE,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,uBAAuB;IACvB,+DAAqE;IACrE,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,uBAAuB;IACvB,+DAAmE;IACnE,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,uBAAuB;IACvB,+DAAqE;IACrE,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA,qBAAqB;;AAErB;IACI,oBAAoB;IACpB,gBAAgB;IAChB;;;mEAGmD;AACvD;;AAEA;IACI,oBAAoB;IACpB,gBAAgB;IAChB;;;mEAGqD;AACzD;;AAEA;IACI,oBAAoB;IACpB,gBAAgB;IAChB;;;mEAGoD;AACxD;;AAEA;IACI,oBAAoB;IACpB,gBAAgB;IAChB;;;mEAGkD;AACtD;;AAEA;IACI,oBAAoB;IACpB,gBAAgB;IAChB;;;mEAGmD;AACvD","sourcesContent":["/* LOAD VODAFONE FONTS */\n\n@font-face {\n    font-family: 'Vodafone';\n    src: url('vodafone/vodafone-lt/Vodafone_Lt.ttf') format('truetype');\n    font-style: normal;\n    font-weight: 200;\n    font-display: swap;\n}\n\n@font-face {\n    font-family: 'Vodafone';\n    src: url('vodafone/vodafone-bk/Vodafone_Bk.ttf') format('truetype');\n    font-style: normal;\n    font-weight: 350;\n    font-display: swap;\n}\n\n@font-face {\n    font-family: 'Vodafone';\n    src:\n        url('vodafone/vodafone-rg/Vodafone_Rg.woff2') format('woff2'),\n        url('vodafone/vodafone-rg/Vodafone_Rg.woff') format('woff'),\n        url('vodafone/vodafone-rg/Vodafone_Rg.ttf') format('truetype');\n    font-style: normal;\n    font-weight: 400;\n    font-display: swap;\n}\n\n@font-face {\n    font-family: 'Vodafone';\n    src: url('vodafone/vodafone-md/Vodafone_Md.ttf') format('truetype');\n    font-style: normal;\n    font-weight: 500;\n    font-display: swap;\n}\n\n@font-face {\n    font-family: 'Vodafone';\n    src: url('vodafone/vodafone-sbd/Vodafone_SBd.ttf') format('truetype');\n    font-style: normal;\n    font-weight: 600;\n    font-display: swap;\n}\n\n@font-face {\n    font-family: 'Vodafone';\n    src: url('vodafone/vodafone-bd/Vodafone_Bd.ttf') format('truetype');\n    font-style: normal;\n    font-weight: 700;\n    font-display: swap;\n}\n\n@font-face {\n    font-family: 'Vodafone';\n    src: url('vodafone/vodafone-xbd/Vodafone_XBd.ttf') format('truetype');\n    font-style: normal;\n    font-weight: 900;\n    font-display: swap;\n}\n\n/* LOAD AMIGO FONTS */\n\n@font-face {\n    font-family: 'Amigo';\n    font-weight: 200;\n    src:\n        url('amigo/amigo-Light.woff2') format('woff2'),\n        url('amigo/amigo-Light.woff') format('woff'),\n        url('amigo/amigo-Light.ttf') format('truetype');\n}\n\n@font-face {\n    font-family: 'Amigo';\n    font-weight: 400;\n    src:\n        url('amigo/amigo-Regular.woff2') format('woff2'),\n        url('amigo/amigo-Regular.woff') format('woff'),\n        url('amigo/amigo-Regular.ttf') format('truetype');\n}\n\n@font-face {\n    font-family: 'Amigo';\n    font-weight: 500;\n    src:\n        url('amigo/amigo-Medium.woff2') format('woff2'),\n        url('amigo/amigo-Medium.woff') format('woff'),\n        url('amigo/amigo-Medium.ttf') format('truetype');\n}\n\n@font-face {\n    font-family: 'Amigo';\n    font-weight: 700;\n    src:\n        url('amigo/amigo-Bold.woff2') format('woff2'),\n        url('amigo/amigo-Bold.woff') format('woff'),\n        url('amigo/amigo-Bold.ttf') format('truetype');\n}\n\n@font-face {\n    font-family: 'Amigo';\n    font-weight: 900;\n    src:\n        url('amigo/amigo-Black.woff2') format('woff2'),\n        url('amigo/amigo-Black.woff') format('woff'),\n        url('amigo/amigo-Black.ttf') format('truetype');\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
